import React from 'react';
import { Col, Row } from 'antd';
import { Resizable, ResizableBox } from 'react-resizable';
// import { addSgiSplitterCtlDndInfo } from '../sgiDndDev/sgiDndDevComFun';
import { convertModuleByGuid } from "./SgiCompComm";
import { addCtnCommonAttribute, sgiCtnBaseFun } from "./SgiCtnComm";
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon';
import { testReactVsn } from './sgiBaseComp/SgiCommon';
// import '../node_modules/react-resizable/css/styles.css';

const ResizeablePanel = (props) => {
	const { onResize, width, height, isLast, sons, ...restProps } = props;

	if (!restProps.style) restProps.style = {};
	restProps.style.width = width;
	restProps.style.height = height;
	return isLast ? <div {...restProps}>{sons}</div> :
		<Resizable width={width} height={height} onResize={onResize}>
			<div {...restProps}>{sons}</div>
		</Resizable>
};

class SgiSplitter extends React.Component {

	static defaultProps = {
	};  // 注意这里有分号
	static propTypes = {
	};  // 注意这里有分号

	constructor(props) {
		super(props);

		//初始化state属性
		//初始化state
		this.state = {
			json: undefined,
			splitProps: { style: { height: '100%', width: '100%' } },
			sonItems: [], //split下数据数组
			sonComps: [], //split下组件数组
			loading: false,
			resizable: false,
			splitId: "splitter_" + uuid(8),
			splitWidth: 1000,
		};
	}

    /**
     * 根据描述创建文本框
     * @param {弹出页面guid} uid
     * @param {对象工厂} objFct
     * @param {弹出窗标题} curtitle
     */
	splitter_mk(parentModule, moduleDesc, objFct, type) {
		//获取需要展示的数据信息
		if (!moduleDesc) {
			return;
		}
		this.state.sonComps = []; //再次渲染的时候清空
		//转换split公共属性
		addCtnCommonAttribute(this, moduleDesc, this.state.splitProps);
		//转换基础属性
		this.AddAttribute(moduleDesc, this.state.splitProps, type);
		//组装分割面板数据
		if (type !== "dnd") this.setSonItems(moduleDesc, this.state.sonComps, this.state.sonItems);
		//添加拖拽布局信息 根据type类型
		// addSgiSplitterCtlDndInfo(this, this.state.sonComps, this.state.splitProps, type);
		let addSgiSplitterCtlDndInfo = this.props.addSgiSplitterCtlDndInfo;//显示/开发分离，这部分拖拽开发功能使用props传入
		if (addSgiSplitterCtlDndInfo && typeof addSgiSplitterCtlDndInfo === "function") {
			addSgiSplitterCtlDndInfo(this, this.state.sonComps, this.state.splitProps, this.props.type);
		}
	}


	AddAttribute = function (moduleDesc, splitProps, type) {
		// 可拖动
		this.state.resizable = (type === "dnd") ? false : (!!moduleDesc.resz);
	}


    /**
     * 添加子控件
     */
	setSonItems = function (moduleDesc, sonComps, sonItems) {
		if (this.state.resizable) {
			this.setResizeItems(moduleDesc, sonComps, sonItems);
		} else {
			this.setRowColItems(moduleDesc, sonComps);
		}
	}

    /**
     * 添加子控件
     */
	setRowColItems = function (moduleDesc, sonComps) {
		let { bdInst, objFct, type } = this.props;
		let colList;
		//分割比例
		var p = moduleDesc.sptSca;
		var ps = p.split(",");

		//计数
		var sumPs = 0;
		for (var i = 0; i < ps.length; i++) {
			sumPs += parseInt(ps[i]);
		}
		var isEdwSpt = moduleDesc.isEdwSpt;//纵向分割

		colList = [];
		var children = moduleDesc.cldSet;
		if (children) {
			var childSize = children.length;
			if (childSize != 0) {
				for (var i = 0; i < childSize; i++) {
					if (!ps[i]) {
						ps[i] = 0;
					}
					var span = Math.round((parseInt(ps[i]) / sumPs) * 24);
					var height1 = (parseInt(ps[i]) / sumPs) * 100 + "%";

					if (isEdwSpt) {
						colList.push(<Row style={{ height: height1, width: '100%' }} >
							{convertModuleByGuid(this, children[i], bdInst, objFct, type)}</Row>)
					} else {
						colList.push(<Col span={span} style={{ height: '100%' }}>
							{convertModuleByGuid(this, children[i], bdInst, objFct, type)}</Col>)
					}
				}
				if (isEdwSpt) {
					sonComps.push(colList);
				} else {
					sonComps.push(<Row style={{ height: '100%', width: '100%' }} > {colList}</Row >);
				}
			}
		}
	}
    /**
     * 添加子控件
     */
	setResizeItems = function (moduleDesc, sonComps, sonItems) {
		let { bdInst, objFct, type } = this.props;
		let colList;
		//分割比例
		var p = moduleDesc.sptSca;
		var ps = p.split(",");

		//计数
		var sumPs = 0;
		for (var i = 0; i < ps.length; i++) {
			sumPs += parseInt(ps[i]);
		}
		var isEdwSpt = moduleDesc.isEdwSpt;//纵向分割

		// let splitWidth = document.getElementById(this.state.splitId).offsetWidth;
		let splitWidth = this.state.splitWidth;

		colList = [];
		var children = moduleDesc.cldSet;
		if (children) {
			var childSize = children.length;
			if (childSize != 0) {
				for (var i = 0; i < childSize; i++) {
					if (!ps[i]) {
						ps[i] = 0;
					}
					let prc = (parseInt(ps[i]) / sumPs);
					var height1 = (parseInt(ps[i]) / sumPs) * 100 + "%";

					if (isEdwSpt) {
						colList.push(<Row style={{ height: height1, width: '100%' }} >
							{convertModuleByGuid(this, children[i], bdInst, objFct, type)}</Row>)
					} else {
						sonItems.push({ prc, initPrc: prc, height: "100%", sons: convertModuleByGuid(this, children[i], bdInst, objFct, type) });
					}
				}
				if (isEdwSpt) {
					sonComps.push(colList);
				} else {
					sonComps.push(<Row style={{ height: '100%', width: '100%' }} > {colList}</Row >);
				}
			}
		}
	}

	refresh = () => {
		this.loaded = false;
		this.setState({ loading: false });
	}

	handleResize = (index, event, { element, size }) => {
		let w1 = this.state.sonItems[index].width;
		let w2 = this.state.sonItems[index + 1].width;
		let sw = w1 + w2;
		this.state.sonItems[index].width = size.width;
		this.state.sonItems[index].prc = size.width / this.state.splitWidth;
		this.state.sonItems[index + 1].width = sw - size.width;
		this.state.sonItems[index + 1].prc = (sw - size.width) / this.state.splitWidth;
		if (testReactVsn(this, 16)) {
			// react16需要更新引用
			this.state.sonItems = [...this.state.sonItems];
		}
		this.setState({});

		// 刷新子分割面板
		this.refreshSonSplit(this.refs);
	};

	//渲染并返回一个虚拟DOM
	render = function () {

		const { parentModule, moduleDesc, bdInst, objFct, type } = this.props;

		if (!this.loaded || this.props.type == 'dnd') {
			//组装属性 初始化属性到this.state
			this.splitter_mk(parentModule, moduleDesc, objFct, type);
			this.loaded = true;
		}

		// 通用渲染前处理，添加自定义样式等
		this.renderBeforeReturn(this.state.splitProps);

		if (this.state.resizable) {
			this.state.sonComps = this.state.sonItems.map((item, index, arr) => {
				if (!item.width) item.width = item.prc * this.state.splitWidth;
				return <ResizeablePanel {...item} isLast={arr.length === (index + 1)} onResize={this.handleResize.bind(this, index)} />
			});
			// 姑且仅支持横向布局
			this.state.splitProps.style.display = "flex";
		}

		return (
			<div className="sgiSplitter" id={this.state.splitId} {...this.state.splitProps} >
				{this.state.sonComps}
			</div >
		);
	}

	// 调整可拖动宽度
	resizeWidth() {
		try {
			let splitWidth = document.getElementById(this.state.splitId).offsetWidth;
			let oldWidth = this.state.splitWidth;
			if (splitWidth !== oldWidth) {
				// 更新组件宽度
				this.state.splitWidth = splitWidth;
				(this.state.sonItems || []).forEach(s => {
					s.width = s.prc * splitWidth;
				});
				if (testReactVsn(this, 16)) {
					// react16需要更新引用
					this.state.sonItems = [...this.state.sonItems];
				}
				this.setState({});
			}
		} catch (error) {

		}
	}

	// 刷新子分割面板
	refreshSonSplit(refs) {
		for (const key in refs) {
			let ref = refs[key];
			if (ref instanceof SgiSplitter) {
				tool.sgiLogger.log('ref :', ref);
				ref.setState({});
			}
			if (ref.refs) {
				this.refreshSonSplit(ref.refs);
			}
		}
	}

	componentDidMount() {
		if (this.state.resizable && this.resizeWidth());
	}

	componentDidUpdate() {
		if (this.state.resizable && this.resizeWidth());
	}

}
//给类添加公共方法
Object.assign(SgiSplitter.prototype, sgiCtnBaseFun);
export { SgiSplitter };
export default SgiSplitter;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiSplitter.js